var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tree-select',{staticStyle:{"width":"100%"},attrs:{"dropdownStyle":_vm.dropDownStyle,"multiple":_vm.multiple,"placeholder":_vm.l('FilterByPermission'),"value":_vm.selectedPermissionVal,"treeData":_vm.treeData,"allowClear":"","showSearch":"","treeDefaultExpandAll":""},on:{"change":function($event){return _vm.selectedChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }